import { Component, OnInit } from '@angular/core';
import { LibraryService,MentorService} from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assignact',
  templateUrl: './assignact.component.html',
  styleUrls: ['./assignact.component.scss'],
  providers:[LibraryService,MentorService]
})
export class AssignactComponent implements OnInit {

  

    // books: Book[];
     memberdetails:any[]=[];
     classdetails:any[]=[];
     closeResult: string;
    
     student:boolean=true;
     staff:boolean=false;
     memberdash:any={};
     arrschh=[];
     arrschd=[];
     arrclass=[];
     arrstudent=[];
     selcls:any;
     selstu:any;
     objschh:any={};
     stfid:any;
     objschd:any={};

     modalOptions:NgbModalOptions;
     private modalRef: NgbModalRef;
     fserdt:any;
     fserdt4:any;
     classes=[];
     selclass:any;
     schdt:any;
   
     constructor(private http: HttpClient, private liservice: LibraryService,private mentservice: MentorService,private modalService: NgbModal) 
     {

      this.stfid=localStorage.getItem('usid');
    var d=new Date();
    this.fserdt=this.mentservice.getdatetoday();
    this.fserdt4=this.mentservice.getdatetoday();
    this.schdt=this.mentservice.getdatetoday();
      }
   
     open(content) {
       this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
         this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
     }
   
     private getDismissReason(reason: any): string {
       if (reason === ModalDismissReasons.ESC) {
         return 'by pressing ESC';
       } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
         return 'by clicking on a backdrop';
       } else {
         return `with: ${reason}`;
       }
     }
   
   
   
     ngOnInit(): void {
       
       this.getschedules('selsch');
       //this.masclassdetails();
       this.classarrdetails();
     }

     
  classarrdetails() {
    this.mentservice.classmaster()
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
           //resultArray.splice(0,1);
            this.selclass=resultArray[0].clid;
            let resSTR = JSON.stringify(resultArray);
          
            this.composefilterclass(resSTR);
            
        },
        error => console.log("Error :: " + error)
        )
  }
  composefilterclass(jstring)
  {
    var newstr = jstring.replace(/clid/g, "value"); 
    var newstr = newstr.replace(/clname/g, "label"); 
    console.log('jsonrep',newstr);
    let resJSON = JSON.parse(newstr);
    var arr=Array.of(resJSON);
    
    this.classes=arr[0];
    console.log('classes',this.classes);
  }
     getschedules(oprtype) {
       debugger;
       this.mentservice.getmentschedules(oprtype,this.fserdt,this.fserdt4)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
             
               this.arrschh = resultArray;
             
               
           },
           error => console.log("Error :: " + error)
           )
     }
     getstudentdata(oprtype) {
      this.mentservice.getstualloted(this.selclass,this.stfid,oprtype)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
             //resultArray.splice(0,1);
            //  let objval:any={};
            //  objval.name='All';
            //  objval.stuid='0';
            //  resultArray.splice(0, 0, objval);
              this.arrstudent=resultArray;
              this.objschh.stuid=0;
              
          },
          error => console.log("Error :: " + error)
          )
    }

    Savedtls(stuid)
    {

      debugger;
     /// console.log('Savedtls',this.objschh);
      this.mentservice.savementschedules('inssch',this.schdt,stuid,this.selclass)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
         //resultArray.splice(0,1);
         alert(resultArray.message);
        //  if(resultArray.status=='Success')
        //   {
        //     let localmodref=this.modalRef;
        //     localmodref.close();
        //     this.getschedules('selschh','0');

        //   }
        //  else
        //  {

        //  }
          
      },
      error =>{
        console.log("Error :: " + error);
        alert('Error while processing data');
      } 
      )
    }

    Saveremarkdtls()
    {

      debugger;
      console.log('Savedtls',this.objschd);
      this.mentservice.savementreviews('updremark',this.objschd.schid,this.objschd.remarks)
      .subscribe(
      resultArray => {
          console.log('members-result', resultArray);
         //resultArray.splice(0,1);
         alert(resultArray.message);
         if(resultArray.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            //this.getschedules('selschh','0');
            this.objschd={};

          }
         else
         {

         }
          
      },
      error =>{
        console.log("Error :: " + error);
        alert('Error while processing data');
      } 
      )
    }
onChangeclass(val)
{
  debugger;

  this.selcls=val;
  this.getstudentdata('sel_alloted');
}
     memberdashcnts(oprtype) {
       this.liservice.getmemberdetails(oprtype,'',0,0)
           .subscribe(
           resultArray => {
               console.log('members-result', resultArray);
               this.memberdash = resultArray[0];
               
           },
           error => console.log("Error :: " + error)
           )
     }

     masclassdetails() {
      this.mentservice.classmaster()
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
             //resultArray.splice(0,1);
              this.objschh.clid=resultArray[0].clid;
              this.selcls=resultArray[0].clid;
              this.arrclass=resultArray;
              //let resSTR = JSON.stringify(resultArray);
            
              //this.composefilterclass(resSTR);
              
          },
          error => console.log("Error :: " + error)
          )
    }
    openinfo(content)
    {
      this.objschh={};
      this.getstudentdata('sel_alloted');
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop'
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           // this.Asmtdetls(asid);
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            
        });
    }

    openremark(content,frmdata)
    {
      this.objschd=frmdata;
      //this.getstudentdata('sel_nonalloted');
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop'
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           // this.Asmtdetls(asid);
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            
        });
    }
    
   
     
   
    
   
   
    
   }
